import create from 'zustand'

export type CancelAllType = 'ALL' | 'LIMIT' | 'STOP'

interface cancelAllStore {
  type: CancelAllType
  updateCancelAllType: (type: CancelAllType) => void
}

export const useCancelAllStore = create<cancelAllStore>((set) => ({
  type: 'ALL',
  updateCancelAllType: (type) => set(() => ({ type })),
}))
